const englishTranslations = {
  appointment: {
    "UPCOMING-APPOINTMENT": {
      topHeading: "View Appointment",
      heading1: "Upcoming",
      heading2: "Past",
      description1: "Fetching information, please wait",
      description2: "There is no Appointment",
      button1: "Book new appointment",
    },
    DOCTOR: {
      topHeading: "Select A Specialist",
      doctorSelectTitle: "Select Doctor",
      doctor1: "Doctor",
      doctor2: "Dietitian ",
      doctor3: "Physio",
      dietitian:
        "Online Appointment booking for Dietitian will be launched soon.",
      physiotherapy:
        "Online appointment booking for Physiotherapy will be launched soon.",
      modal: "You have already booked an appointment with the doctor",
      unavailable_message:
        "{{unavailable}} unavailable. {{available}} will consult you.",
      specialities: {
        Rheumatologist: "Rheumatologist",

        "Consultant Rheumatologist": "Consultant Rheumatologist",

        "Pain Physician & Anesthesiologist":
          "Pain Physician & Anesthesiologist",

        "Pain Management Specialist": "Pain Management Specialist",

        "Orthopaedic and Joint Replacement Surgeon":
          "Orthopaedic and Joint Replacement Surgeon",

        "Consultant Orthopaedic and Speciality Knee Surgeon":
          "Consultant Orthopaedic and Speciality Knee Surgeon",

        "Rheumatologist and Immunologist": "Rheumatologist and Immunologist",

        Dermatologist: "Dermatologist",

        "Consultant Neurologist": "Consultant Neurologist",

        "Consultant Diabetes, Thyroid and Endocrine Specialist":
          "Consultant Diabetes, Thyroid and Endocrine Specialist",
        Dietitian: "Dietitian",
        "Orthopaedic and Knee Surgeon": "Orthopaedic and Knee Surgeon",
      },
    },
    CLINIC: {
      topHeading: "Select Clinic",
      clinic1: "Mumbai - Bhandup",
      clinic2: "Thane - Kalyan ",
      clinic3: "Thane - Dombivali",
      clinic4: "Thane - Badlapur",
      clinic5: "Mumbai - Malad",
      clinic6: "Bliss Clinic (Thane)",
      clinic8: "Mumbai - Santacruz",
      clinic9: "Thane - Airoli",
      clinic10: "AIMS (Thane)",
      clinic11: "Sigma Hospital (Mulund West)",
      clinic12: "Good Health Clinics (Bhandup West)",
      clinic13: "Good Health Clinics (Bhandup East)",
      clinic14: "Nirjara Multispecialty Clinic (Kandivali West)",
      clinic15: "Advanced arthritis and Rheumatology Center",

      clinic17: "AMORAC (Mumbai)",
      clinic18: "ELIOS Hospital (Nagpur)",
      clinic19: "PAIN CLINIC OF INDIA (Chembur)",
      clinic20: "Dr.Das’s Pain Care Clinic (Thane)",
      clinic21: "Shreshtha Arthritis and Rumetology Clinic (Vijayawada)",
      clinic22: "RheuGlow Clinic (Palava)",
      clinic23: "Gleneagles Hospital (Parel)",
      clinic24: "ELIOS Hospital (Nagpur)",

      clinic0: "Online",
      kalyan: "Online appointment booking for Kalyan will be launched soon.",
      online:
        "Online appointment booking for Online consultation will be launched soon.",
    },
    DATE: { date: "Select A Date" },
    TIME: { time: "Select Time Slot" },
    CONFIRMED: {
      message1: "Appointment Confirmation",
      message2: "Confirm Appointment",
      message3: "Your Appointment",
      message4: "confirmed",
      "doctor-name": "Dr. Akerkar",
      clinic1: "Bhandup",
      clinic2: "Kalyan",
      clinic3: "Dombivali",
      clinic4: "Badlapur",
      clinic5: "Malad",
      clinic6: "Thane",
      clinic8: "Santacruz",
      clinic9: "Airoli",
      clinic10: "AIMS (Thane)",
      clinic11: "Sigma Hospital (Mulund West)",
      clinic12: "Good Health Clinics (Bhandup West)",
      clinic13: "Good Health Clinics (Bhandup East)",
      clinic14: "Nirjara Multispecialty Clinic (Kandivali West)",
      clinic15: "Advanced arthritis and Rheumatology Center",
      clinic17: "AMORAC (Mumbai)",
      clinic18: "ELIOS Hospital (Nagpur)",
      clinic19: "PAIN CLINIC OF INDIA (Chembur)",
      clinic20: "Dr.Das’s Pain Care Clinic (Thane)",
      clinic21: "Shreshtha Arthritis and Rumetology Clinic (Vijayawada)",
      clinic22: "RheuGlow Clinic (Palava)",
      clinic23: "Gleneagles Hospital (Parel)",
      clinic24: "ELIOS Hospital (Nagpur)",

      clinic0: "Online",
    },
    "MY-APPOINT": { "my-appoint": "My Appointment" },

    WAITLIST: {
      topHeading: "waiting List",
      message1: "No appointments are available on",
      button2: "Choose a different date",
      button3: "Add me to the waiting list",
      message3: "You have been successfully added to the",
      open: "Clinic will get in touch with you.",
      message4:
        "Your appointment is confirmed. Dr.Akerkar 10:00 AM, 15th April, 2021 Bhandup.",
    },
    CANCEL: {
      cancel: "Are you sure you want to cancel the appointment?",
      yes: "Yes, Cancel",
      no: "No, don't",
    },
    BUTTON: {
      cancel: "Cancel",
      reschedule: "Reschedule",
      completed: "Completed",
      confirm: "Confirm",
      waitListed: "WaitListed",
      ok: "Ok",
      save: "Save",
      change: "Change",
      verify: "Verify",
    },
    "FORGET-PASSWORD": {
      message1: "Forgot Your Password?",
      message2: "Enter your registered Patient ID below",
      message22: "to receive password reset instruction",
      message3: "Check Your SMS",
      message4: "We have sent a password recovery instruction",
    },
    MYCLINIC: {
      appointment: "Appointment",
      payment: "Payment",
      message: "Message",
      coming: "Coming Soon",
    },

    "EMAIL-VALIDATION": {
      message1: "Email fields cannot be empty",
      message2: "Email seems invalid",
      message3: "Email inputs aren't matching",
    },
  },
};

const marathiTranslations = {
  appointment: {
    "UPCOMING-APPOINTMENT": {
      topHeading: "अपॉइंटमेंट पहा",
      heading1: "येणारे",
      heading2: "आधीचे",
      description1: "आम्ही माहिती आणत आहोत, कृपया प्रतीक्षा करा",
      description2: "अपॉइंटमेंट बुक केलेली नाही",
      button1: "नवीन अपॉइंटमेंट बुक करा",
    },
    DOCTOR: {
      topHeading: "एक तज्ञ निवडा",
      doctorSelectTitle: "डॉक्टर निवडा",
      doctor1: "डॉक्टर",
      doctor2: "आहारतज्ञ",
      doctor3: "फिजिओथेरपिस्ट",
      dietitian:
        "आहारतज्ज्ञांसाठी ऑनलाइन अपॉइंटमेंट बुकिंग लवकरच सुरू होणार आहे",
      physiotherapy:
        "फिजिओथेरपीसाठी ऑनलाइन अपॉइंटमेंट बुकिंग लवकरच सुरू केली जाईल",
      modal: "तुम्ही आधीच डॉक्टरांची अपॉइंटमेंट बुक केली आहे",

      unavailable_message: "{{unavailable}} नाहीत. {{available}} बघतील.",
      specialities: {
        Rheumatologist: "संधिवात तज्ञ",

        "Consultant Rheumatologist": "कंसल्टेंट संधिवात तज्ञ",

        "Pain Physician & Anesthesiologist": "वेदना चिकित्सक आणि भूलतज्ज्ञ",

        "Pain Management Specialist": "वेदना उपचार तज्ज्ञ",

        "Orthopaedic and Joint Replacement Surgeon":
          "ऑर्थोपेडिक आणि जॉइंट रिप्लेसमेंट सर्जन",

        "Orthopaedic and Knee Surgeon": "ऑर्थोपेडिक आणि गुडघ्याचे सर्जन",

        "Rheumatologist and Immunologist": "संधिवात तज्ञ आणि इम्युनोलॉजिस्ट",

        Dermatologist: "त्वचारोग तज्ज्ञ",

        "Consultant Neurologist": "कन्सल्टंट न्यूरोलॉजिस्ट",

        "Consultant Diabetes, Thyroid and Endocrine Specialist":
          "मधुमेह, थायरॉईड व हार्मोन तज्ज्ञ",

        Dietitian: "आहारतज्ञ",
      },
    },
    CLINIC: {
      topHeading: "क्लिनिक निवडा",
      clinic0: "ऑनलाइन",

      clinic1: "मुंबई - भांडुप",
      clinic2: "ठाणे - कल्याण",
      clinic3: "ठाणे - डोंबिवली",
      clinic4: "ठाणे - बदलापूर",
      clinic5: "मुंबई - मालाड",
      clinic6: "ब्लिस क्लिनिक (ठाणे)",
      clinic8: "मुंबई - सांताक्रूझ",
      clinic9: "ठाणे - ऐरोली",
      clinic10: "एम्स (ठाणे)",
      clinic11: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
      clinic12: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
      clinic13: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
      clinic14: "निर्जरा मल्टीस्पेशालिटी क्लिनिक (कांदिवली पश्चिम)",
      clinic15: "अॅडव्हान्स्ड आर्थरायटिस अँड र्‍ह्युमेटोलॉजी सेंटर",
      clinic17: "अमोरॅक (मुंबई)",
      clinic18: "ELIOS हॉस्पिटल (नागपूर)",
      clinic19: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
      clinic20: "डॉ. दास पेन केयर क्लिनिक (ठाणे)",
      clinic21: "श्रेष्ठ आर्थरायटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाडा)",
      clinic22: "RheuGlow क्लिनिक (पलावा)",
      clinic23: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
      clinic24: "एलिओस हॉस्पिटल (नागपूर)",

      kalyan: "कल्याणसाठी ऑनलाइन अपॉइंटमेंट बुकिंग लवकरच सुरू होणार आहे",
      online:
        "ऑनलाइन अपॉइंटमेंटसाठी ऑनलाइन अपॉइंटमेंट बुकिंग लवकरच सुरू केली जाईल",
    },
    DATE: { date: "एक तारीख निवडा" },
    TIME: { time: "एक वेळ निवडा" },

    CONFIRMED: {
      message1: "भेटीची पुष्टीकरण",
      message2: "भेटीची पुष्टी करा",
      message3: "तुमची भेट",
      message4: "पुष्टी केली",
      "doctor-name": "डॉ. आकेरकर",
      clinic1: "भांडुप",
      clinic2: "कल्याण",
      clinic3: "डोंबिवली",
      clinic4: "बदलापूर",
      clinic5: "मालाड",
      clinic6: "ठाणे",
      clinic8: "सांताक्रूझ",
      clinic9: "ऐरोली",
      clinic10: "एम्स (ठाणे)",
      clinic11: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
      clinic12: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
      clinic13: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
      clinic14: "निर्जरा मल्टीस्पेशालिटी क्लिनिक (कांदिवली पश्चिम)",
      clinic15: "अॅडव्हान्स्ड आर्थरायटिस अँड र्‍ह्युमेटोलॉजी सेंटर",
      clinic17: "अमोरॅक (मुंबई)",
      clinic18: "ELIOS हॉस्पिटल (नागपूर)",
      clinic19: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
      clinic20: "डॉ. दास पेन केयर क्लिनिक (ठाणे)",
      clinic21: "श्रेष्ठ आर्थरायटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाडा)",
      clinic22: "RheuGlow क्लिनिक (पलावा)",
      clinic23: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
      clinic24: "एलिओस हॉस्पिटल (नागपूर)",

      clinic0: "ऑनलाइन",
    },
    "MY-APPOINT": { "my-appoint": "माझी भेट" },

    WAITLIST: {
      topHeading: "प्रतिक्षा यादी",
      message1: "साठी कोणत्याही अपॉइंटमेंट उपलब्ध नाहीत.",
      button2: "वेगळी तारीख निवडा",
      button3: "मला प्रतीक्षा यादीत सामील करा",
      message3: "मध्ये तुम्हाला यशस्वीपणे सामील केले आहे.",
      open: "क्लिनिक तुमच्याशी संपर्क साधेल.",
      message4:
        "तुमची अपॉइंटमेंट बुक झाली आहे डॉ. आकेरकर १०:०० सकाळी १५ एप्रिल, गुरुवार, २०२१ भांडुप.",
    },
    CANCEL: {
      cancel: "तुम्हाला खात्री आहे की तुम्ही भेट रद्द करू इच्छिता?",
      yes: "होय, रद्द करा",
      no: "नाही, नको",
    },
    BUTTON: {
      cancel: "रद्द करा",
      reschedule: "अपॉइंटमेंट बदला",
      completed: "अपॉइंटमेंट पूर्ण झाली",
      confirm: "पुष्टी करा",
      waitListed: "तुम्ही प्रतीक्षा यादीत आहात",
      ok: "ठीक आहे",
      save: "सेव्ह करा",
      change: "बदला",
      verify: "सत्यापित करा",
    },
    "FORGET-PASSWORD": {
      message1: "तुमचा पासवर्ड विसरलात?",
      message2: "पासवर्ड रीसेट सूचना प्राप्त करण्यासाठी",
      message22: "खाली तुमचा नोंदणीकृत पेशंट आयडी एंटर करा",
      message3: "तुमचा एसएमएस तपासा",
      message4: "आम्ही पासवर्ड रिकव्हरी सूचना पाठवली आहे",
    },
    MYCLINIC: {
      appointment: "अपॉइंटमेंट",
      payment: "पेमेंट",
      message: "मेसेज",
      coming: "लवकरच येत आहे",
    },
    "EMAIL-VALIDATION": {
      message1: "ईमेल फील्ड रिकामे असू शकत नाहीत",
      message2: "ईमेल अवैध वाटत आहे",
      message3: "ईमेल इनपुट जुळत नाहीत",
    },
  },
};

const hindiTranslations = {
  appointment: {
    "UPCOMING-APPOINTMENT": {
      topHeading: "अपॉइंटमेंट देखें",
      heading1: "आगे आनेवाले",
      heading2: "पिछले",
      description1: "जानकारी लाई जा रही है, कृपया प्रतीक्षा करें",
      description2: "कोई अपॉइंटमेंट बुक नहीं हैं",
      button1: "नई अपॉइंटमेंट बुक करें",
    },
    DOCTOR: {
      topHeading: "एक डॉक्टर चुनें",
      doctorSelectTitle: "डॉक्टर चुनें",
      doctor1: "डॉक्टर",
      doctor2: "आहार विशेषज्ञ",
      doctor3: "फिजियोथेरेपिस्ट",
      dietitian: "डायटीशियन के लिए ऑनलाइन अपॉइंटमेंट बुकिंग जल्द शुरू की जाएगी",
      physiotherapy:
        "फिजियोथेरेपी के लिए ऑनलाइन अपॉइंटमेंट बुकिंग जल्द शुरू की जाएगी",
      modal: "आपने पहले ही डॉक्टर के साथ अपॉइंटमेंट बुक कर लिया हैं",
      unavailable_message:
        "{{unavailable}} उपलब्ध नहीं हैं। {{available}} आपको देखेंगी।",
      specialities: {
        Rheumatologist: "ह्रुमेटोलॉजिस्ट",

        "Consultant Rheumatologist": "कंसल्टेंट ह्रुमेटोलॉजिस्ट",

        "Pain Physician & Anesthesiologist":
          "दर्द चिकित्सक एवं एनेस्थेसियोलॉजिस्ट",

        "Pain Management Specialist": "दर्द उपचार विशेषज्ञ",

        "Orthopaedic and Joint Replacement Surgeon":
          "ऑर्थोपेडिक और जॉइंट रिप्लेसमेंट सर्जन",

        "Orthopaedic and Knee Surgeon": "ऑर्थोपेडिक और घुटने के सर्जन",

        "Rheumatologist and Immunologist": "रुमेटोलॉजिस्ट और इम्यूनोलॉजिस्ट",

        Dermatologist: "त्वचा रोग विशेषज्ञ",

        "Consultant Neurologist": "कंसल्टेंट न्यूरोलॉजिस्ट",

        "Consultant Diabetes, Thyroid and Endocrine Specialist":
          "मधुमेह, थायरॉइड एवं हार्मोन रोग विशेषज्ञ",

        Dietitian: "आहार विशेषज्ञ",
      },
    },
    CLINIC: {
      topHeading: "एक क्लिनिक चुनें",
      clinic0: "ऑनलाइन",
      clinic1: "मुंबई - भांडुप",
      clinic2: "ठाणे - कल्याण",
      clinic3: "ठाणे - डोंबिवली",
      clinic4: "ठाणे - बदलापुर",
      clinic5: "मुंबई - मलाड",
      clinic6: "ब्लिस क्लिनिक (ठाणे)",
      clinic8: "मुंबई - सांताक्रूज़",
      clinic9: "ठाणे - ऐरोली",
      clinic10: "एम्स (ठाणे)",
      clinic11: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
      clinic12: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
      clinic13: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
      clinic14: "निर्जरा मल्टीस्पेशलिटी क्लिनिक (कांदिवली पश्चिम)",
      clinic15: "एडवांस्ड आर्थराइटिस एंड रियूमेटोलॉजी सेंटर",
      clinic17: "अमोरॅक (मुंबई)",
      clinic18: "ELIOS हॉस्पिटल (नागपूर)",
      clinic19: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
      clinic20: "डॉ. दास पेन केयर क्लिनिक (ठाणे)",
      clinic21: "श्रेष्ठ आर्थराइटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाड़ा)",
      clinic22: "RheuGlow क्लिनिक (पलावा)",
      clinic23: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
      clinic24: "एलिओस हॉस्पिटल (नागपुर)",
      kalyan: "कल्याण के लिए ऑनलाइन अपॉइंटमेंट बुकिंग जल्द ही शुरू की जाएगी",
      online:
        "ऑनलाइन अपॉइंटमेंट के लिए ऑनलाइन अपॉइंटमेंट बुकिंग जल्द ही शुरू की जाएगी",
    },
    DATE: { date: "एक तारीख चुनें" },
    TIME: { time: "एक समय चुनें" },

    CONFIRMED: {
      message1: "अपॉइंटमेंट की जाँच",
      message2: "अपॉइंटमेंट की जाँच करें",
      message3: "आपका अपॉइंटमेंट की",
      message4: "जाँच की",
      "doctor-name": "डॉ. आकेरकर",
      clinic1: "भांडुप",
      clinic2: "कल्याण",
      clinic3: "डोंबिवली",
      clinic4: "बदलापूर",
      clinic5: "मलाड",
      clinic6: "ठाणे",
      clinic8: "सांताक्रूज",
      clinic0: "ऑनलाइन",
      clinic9: " ऐरोली",
      clinic10: "एम्स (ठाणे)",
      clinic11: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
      clinic12: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
      clinic13: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
      clinic14: "निर्जरा मल्टीस्पेशलिटी क्लिनिक (कांदिवली पश्चिम)",
      clinic15: "एडवांस्ड आर्थराइटिस एंड रियूमेटोलॉजी सेंटर",
      clinic17: "अमोरॅक (मुंबई)",
      clinic18: "ELIOS हॉस्पिटल (नागपूर)",
      clinic19: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
      clinic20: "डॉ. दास पेन केयर क्लिनिक (ठाणे)",
      clinic21: "श्रेष्ठ आर्थराइटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाड़ा)",
      clinic22: "RheuGlow क्लिनिक (पलावा)",
      clinic23: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
      clinic24: "एलिओस हॉस्पिटल (नागपुर)",
    },
    "MY-APPOINT": { "my-appoint": "मेरा अपॉइंटमेंट" },

    WAITLIST: {
      topHeading: "प्रतीक्षा सूची",
      message1: "के लिए कोई अपॉइंटमेंट उपलब्ध नहीं हैं।",
      button2: "कोई अलग तारीख चुनें।",
      button3: "मुझे प्रतीक्षा सूची में डालें।",
      message3: "में आपको सफलतापूर्वक जोड़ दिया गया हैं।",
      open: "क्लिनिक आपसे संपर्क करेगा।",
      message4:
        "आपका अपॉइंटमेंट बुक हो गया है। डॉ आकेरकर 10:00 सुबेह 15 अप्रैल, गुरुवार, 2021 भांडुप",
    },
    CANCEL: {
      cancel: "क्या आप वाकई अपॉइंटमेंट रद्द करना चाहते हैं?",
      yes: "हाँ रद्द करें",
      no: "नहीं, मत करो",
    },
    BUTTON: {
      cancel: "रद्द करें",
      reschedule: "अपॉइंटमेंट बदलें",
      completed: "अपॉइंटमेंट पूर्ण हो गई हैं",
      confirm: "जाँच करें",

      waitListed: "आप प्रतीक्षा सूची में हैं",
      ok: "ठीक हैं",
      save: "सेव करें",
      change: "बदलें",
      verify: "सत्यापित करना",
    },
    "FORGET-PASSWORD": {
      message1: "क्या आप पासवर्ड भूल गए?",
      message2: "पासवर्ड रीसेट निर्देश प्राप्त करने के",
      message22: "लिए नीचे अपना पंजीकृत पेशंट आईडी दर्ज करें",
      message3: "अपना एसएमएस जांचें",
      message4: "हमने एक पासवर्ड पुनर्प्राप्ति निर्देश भेजा हैं",
    },
    MYCLINIC: {
      appointment: "अपॉइंटमेंट",
      payment: "भुगतान",
      message: "संदेश",
      coming: "जल्द आ रहा हैं",
    },
    "EMAIL-VALIDATION": {
      message1: "ईमेल फ़ील्ड खाली नहीं हो सकते",
      message2: "ईमेल अमान्य लगता हैं",
      message3: "ईमेल इनपुट मेल नहीं खा रहे हैं",
    },
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
